import { STATE_VALUE } from './constant';

export function formatPhoneNumber(value: string) {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, '');
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
    3,
    6,
  )}-${phoneNumber.slice(6, 10)}`;
}

export function formatConfirmationCode(value: string) {
  if (!value) return value;
  const confirmationCode = value.replace(/[^\d]/g, '');
  return confirmationCode;
}

export function formatAddressField(value: string) {
  if (!value) return value;
  const addressField = value.replace(/[^a-zA-Z0-9#/&% ]+/gi, '');
  return addressField;
}

export function formatCityField(value: string) {
  if (!value) return value;
  const cityVal = value.replace(/[^a-zA-Z ]+/gi, '');
  return cityVal;
}

export function stateOption() {
  const state = STATE_VALUE?.map((option: any) => ({
    value: option,
    label: option,
  }));
  return state;
}

export function isValidateEmail(value: string) {
  const re = /\S+@\S+\.\S+/;
  return re.test(value);
}

export function isEmpty(value: string) {
  return value === null || value === undefined || value.trim()?.length === 0;
}

export function isValidatePhoneLength(val: string) {
  return val?.length >= 1 && val?.length < 14;
}

export function isValidateZipLength(val: string) {
  return val?.length >= 1 && val?.length < 5;
}

export function isNoSpace(val: string) {
  return /^\s/.test(val);
}

export function getLoginBrowser() {
  let result = '';
  if (
    (navigator.userAgent.indexOf('Opera') ||
      navigator.userAgent.indexOf('OPR')) !== -1
  ) {
    result = 'Opera';
  } else if (navigator.userAgent.indexOf('Edg') !== -1) {
    result = 'Edge';
  } else if (navigator.userAgent.indexOf('Chrome') !== -1) {
    result = 'Chrome';
  } else if (navigator.userAgent.indexOf('Safari') !== -1) {
    result = 'Safari';
  } else if (navigator.userAgent.indexOf('Firefox') !== -1) {
    result = 'Firefox';
  } else if (
    navigator.userAgent.indexOf('MSIE') !== -1 ||
    !!document.DOCUMENT_NODE === true
  ) {
    result = 'IE';
  } else {
    result = 'unknown';
  }
  return result;
}
